import { LoginService } from './../../_services/login/login.service';
import { LoginRequestModel } from './../../_models/login/LoginRequestModel';
import { GlobalService } from './../../_global/global.service';
import { Component, OnInit } from '@angular/core';
import { PartnerMobileRequest, PartnerOtpValidateRequest, PartnerOnBoardRequest } from '../../_models/login/LoginResponseModel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginCustom } from '../../../app/auth/_helpers/login-custom';
import { Observable } from 'rxjs/Rx';
import * as shajs from 'sha.js';

@Component({
    templateUrl: './validateSignUp.component.html',
})
export class ValidateSignUpComponent implements OnInit {
    partnerName: any;
    partnerOnBoardRequest = new PartnerOnBoardRequest();
    partnerEmail: any;

    urlParamData: string;
    loading = true;
    currentUser: any;
    loginData;
    model: any = {};
    uiList = new Array<any>();
    partnerMobileRequest = new PartnerMobileRequest();
    partnerOtpValidateRequest = new PartnerOtpValidateRequest();

    private _gs: GlobalService = new GlobalService();

    constructor(private _router: Router,

        private route: ActivatedRoute, private _loginService: LoginService,
    ) {

        // this.route.queryParams.subscribe(params => {
        //     this.urlParamData = params;
        //     console.log(this.urlParamData);

        // });

    }

    ngOnInit() {
        //this.getOffersList();
        this.urlParamData = this._router.url;
        this.urlParamData = this.urlParamData.substring(16);
        this.loginData = JSON.parse(atob(this.urlParamData));
        console.log(this.urlParamData);

        // setTimeout(() => {
        //     this.loading = false;
        // }, 1000);

        this.onBoardPartner();
    }


    //LOGIN POST REQUEST
    onBoardPartner() {
        this.loading = true;
        this.partnerOnBoardRequest.partnerName = this.loginData["partnerName"];
        this.partnerOnBoardRequest.email = this.loginData["email"];
        this.partnerOnBoardRequest.firstName = this.loginData["firstName"];
        this.partnerOnBoardRequest.lastName = this.loginData["lastName"];
        this.partnerOnBoardRequest.mobile = this.loginData["mobile"];
        this.partnerOnBoardRequest.pan = this.loginData["pan"];



        this._loginService.onBoardPartner(this.partnerOnBoardRequest).subscribe(
            result => {
                this.loading = false;
                LoginCustom.displayPartnerRegister();
                swal('Success', 'Congratulations! Your registration was successful! Our team will get in touch with you for further processing.', 'success')
                this._router.navigate([""]);
                this.partnerOnBoardRequest = new PartnerOnBoardRequest();
                this.partnerMobileRequest = new PartnerMobileRequest();
                this.partnerOtpValidateRequest = new PartnerOtpValidateRequest();
            },
            error => {
                this.loading = false;
                let err = error.json();
                let errorMessage = err.message;
                // this.partnerOnBoardRequest = new PartnerOnBoardRequest();
                swal('Error',
                    errorMessage,
                    'error'
                );
            }
        );
    }



}


// WEBPACK FOOTER //
// ./src/app/auth/validateSignUp/validateSignUp.component.ts